import React, { useCallback, useEffect, useState } from 'react'
import '../Menu.css'
import './VosAdressesContacts.css'
import MonCompteHeader from '../MonCompteHeader'
import { TypeEmail } from '../../../../Models/Email/EmailModels'
import {BoxAdresseContact} from './template_adresse_contact_box/AdresseContact_box'
import {Magasin } from '../../../../Models/Magasin/MagasinModels'
import { useCookies } from 'react-cookie'
import { TypeEmailService } from '../../../../Services/Email/TypeEmailService'
import { MagasinService } from '../../../../Services/Magasin/MagasinService'
import { Alert, Snackbar, SnackbarCloseReason, Grid, createTheme, ThemeProvider } from '@mui/material'
import { AlerteAction } from '../../../Admin/AffichageAdmin/outil_commun_admin/AlerteAction'

export interface VosAdressesContactsProps{
  setInterfaceMonCompte: any
  interfaceMonCompte: number,
  magasinsClient:Magasin[]
  obtentionDonnees:()=>Promise<void>
}

export function VosAdressesContacts(props: VosAdressesContactsProps) {

  const{setInterfaceMonCompte, interfaceMonCompte, magasinsClient, obtentionDonnees}=props
  const [arrayTypeEmail, setArrayTypeEmail] = useState<TypeEmail[]>([])
  const [cookies] = useCookies(['token'])
  const [loading, setLoading] = useState<boolean>(true)
  
  //services
  const token = cookies.token;

  //gestion snackbar retour info
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarState, setSnackbarState] = useState<string>('');

  //gestion breakpoints grid v2
  const theme = createTheme({
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 900,
        lg: 1200,
        xl: 1900,
      },
    },
  });

  const handleClose = (
      event?: React.SyntheticEvent | Event,
      reason?: SnackbarCloseReason,
    ) => {
      if (reason === 'clickaway') {
        return;
      }
      setOpenSnackbar(false);
  };

  const fetchData = useCallback(async ()=>{
    if(token){
      obtentionDonnees()
      const resultTypes = await TypeEmailService().getAllTypeEmailClients(token);
      setArrayTypeEmail(resultTypes);
      setLoading(false);
    }
  },[obtentionDonnees, token]);

  useEffect(()=>{
    if(loading){
      fetchData();
    }
    return ()=>{}
  },[fetchData, loading]);
  
  return(
    <div className='MonCompte-selected-part'>
      <MonCompteHeader
        setInterfaceMonCompte={setInterfaceMonCompte}
        interfaceMonCompte={interfaceMonCompte}
        mainText={'Vos adresses contacts'}
        subText={
          'Renseigner les personnes en charges de la radio E.leclerc pour votre magasin'
        }
      />
      <div className='MonCompte-body'>
        <ThemeProvider theme={theme}>
          <Grid container spacing={{ xs: 1, md: 2 }} columns={{ xs: 2, sm: 4, md:6, lg:12, xl:12 }}>
            {
              arrayTypeEmail.map((type,index)=>(
                <Grid key={index} size={{ xs: 2, sm: 4, md: 6, lg:6, xl:4 }}>
                  <BoxAdresseContact
                    typeAdresse={type}
                    magasins={magasinsClient}
                    sendLoading={setLoading}
                    loading={loading}
                    setOpenSnackbar={setOpenSnackbar}
                    setSnackbarState={setSnackbarState}
                  />
                </Grid>
              ))
            }
          </Grid>
        </ThemeProvider>
      </div>
      <Snackbar open={openSnackbar} autoHideDuration={2500} onClose={handleClose}>
        {AlerteAction(snackbarState, "L'adresse de contact")}
      </Snackbar>
    </div>
  )
}